import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';

const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Machine'

  }
];

@Component({
  selector: 'page-machine',
  templateUrl: './machine.html',
  styleUrls: ['./machine.scss']
})

export class PageMachine implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  cksearch:boolean=false;
  form: FormGroup;
  machines = [];
  rows = [];
  temp=[];
  key:any="";
  filteredMachine:any;
  machineCtrl:FormControl;
  user_selected = new FormControl();
  users = [];
  fileupload:string;fileupload_:string;
  data:any;
  arr_user=[];
  code:string;name:string;vender:string;ct:string;spec:string;
  loadingIndicator: boolean = true;
  selected=[];
  id:string;
  ckedit:boolean=false;
  picture:String;
  //upload file
  imageSrc:any;
  imageSrc_:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  urlApi_=environment.url+"/api/uploadToserverMachine.php";
  Name:string; 
  myFile:File; /* property of File type */
  myFile_:File;
  print="";
  dialogRefWarning: MdDialogRef<WarningMachineDialog>;
  dialogRef: MdDialogRef<machineDialog>;
  setId:any;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/machine-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/machine-list-export.php";
  ckUrl:boolean=false;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {
    singleSelection: true,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "col-md-12"
  };
  qr:String;
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
  this.getUser();
  this.getMachine();
  this.getStartData();
  this.getProduct();
    this._sharedService.emitChange(this.pageTitle);
  }



  onItemSelect(item: any) {
    //console.log(item);
    console.log('process',this.selectedItems);

    //this.selectedItems.push(item);
  }
  OnItemDeSelect(item: any) {
    //console.log(item);
    //console.log(this.selectedItemsProcess);
  }
  onSelectAll(items: any) {
    //console.log(items);
  }
  onDeSelectAll(items: any) {
    //console.log(items);
  }


  getProduct() {
    this.httpservice.fetchget('getJSON_product.php?', (data) => {
      for (let i = 0; i < data.length; i++) {
        this.dropdownList.push({ "id": data[i].tp_id, "itemName": data[i].tp_part_no });
      }
    });
  }

  intervalGetData(){
    
    return setInterval(() => {
      if(this.setId.runCount>5){
      clearInterval(this.setId);
      }
      this.getStartData();
      console.log('------this.setId------',this.setId.runCount);
     }, 1000);
  }
  onActivate(event) {
    //console.log('Activate Event', event);
  }
  onSelect({ selected }) {
    console.log('Select Event', this.selected);
   
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  getStartData(){

    this.httpservice.fetchget('getJSON_machine.php?',(machine) => {
      this.rows = machine;
      this.temp = machine;
      this.loadingIndicator = false;
      console.log('------this.cksearch------',this.cksearch);
    });
  }

  getUser(){
    this.httpservice.fetchget('getJSON_operator_in_process.php?',(data)=>{
      this.users = data;
    });
  }

  openPrint(){

    for(let i=0;i<this.selected.length;i++){
          
              //console.log('----select---',this.selected[i]['tma_id'],this.selected);
              if(this.selected[i]['tma_id']!="undefined"){
                this.print+="&print[]="+this.selected[i]['tma_id'];
      }    
    }
    
    let popupWinindow
    popupWinindow = window.open( environment.url+'/api/print-machine.php?'+this.print, '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no width=auto');
    this.selected = [];
    this.print="";
    
    }

  getMachine(){
    this.httpservice.fetchget('getJSON_machine_name.php?',(machine) => {
      this.machines = machine.map(function (val) {
        return [val.tma_name];
      });
      console.log('------this.machine------', this.machines);
    });
    this.machineCtrl = new FormControl();
    this.filteredMachine = this.machineCtrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.machines.filter((s) => new RegExp(val, 'gi').test(s)) : this.machines;
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deleteMachine.php', val, (cb) => {});
  this.getStartData();
  }

  setedit(id:string){
    this.cancelEdit();
    this.id = id;
    this.ckUrl = true;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_machine.php?id='+id,(machine) => {
      this.form.controls.code.setValue(machine[0].tma_code);
      this.form.controls.name.setValue(machine[0].tma_name);
      this.form.controls.vender.setValue(machine[0].tma_vendor);
      this.form.controls.ct.setValue(machine[0].tma_ct);
      this.form.controls.spec.setValue(machine[0].tma_detail);
      this.form.controls.model.setValue(machine[0].tma_model);
      this.form.controls.serial.setValue(machine[0].tma_serial);
      this.selectedItems = machine[0].product;
      this.selected=machine[0].admin;
      this.qr = machine[0].tma_qr;
      
      if(machine[0].tma_picture.length>0){
        this.picture = this.sysPath+'/picture/machine/'+machine[0].tma_picture;
      }else{
        this.picture = this.sysPath+'/picture/no_image.jpg';
      }

     // this.picture = machine[0].tma_picture;
      //this.user_selected.setValue("77");

      console.log('machine',machine);
    });
  }

  edit(){
    this.setId = this.intervalGetData();
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }

    if (this.myFile_ != null) {
      this.fileupload_ = this.myFile_.name;
    } else {
      this.fileupload_ = "";
    }
    this.ckedit = false;
    this.data = {
      id:this.id,
      tma_code:this.form.controls.code.value,
      tma_name:this.form.controls.name.value,
      tma_vendor:this.form.controls.vender.value,
      tma_detail:this.form.controls.spec.value,
      tma_ct:0,
      product:this.selectedItems,
      serial:this.form.controls.serial.value,
      model:this.form.controls.model.value,
      filename:this.fileupload,
      filename_:this.fileupload_,
      user:this.user_selected.value
    }
    // insert data
    this.httpservice.fetchpost('editDataMachine.php', this.data, (cb) => {});

    //upload document
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }

    //upload image
  if (this.myFile_ != null) {
    this.uploadPhoto_(this.myFile_);
  }

  
    this.getStartData();
    console.log('------edit ------');
    this.user_selected.reset();
    this.form.reset();
    this.picture = null;


  }

  cancelEdit(){
    this.ckedit = false;
    this.ckUrl = false;
    this.user_selected.reset();
    this.form.reset();
    this.picture = null;
  }

  getInfo(val:string,_event: any,index:any){

    if(_event.isUserInput){
    if(_event.source.selected==true){
      this.arr_user.push(val);
      //console.log('true',_event.source.selected,_event,this.user_selected.value);
    }else{
      this.arr_user.splice(index, 1);
      ///console.log('false',_event.source.selected,_event,this.user_selected.value);
    }

    console.log('arr_user',_event);
  }
  }



save(){
  this.setId = this.intervalGetData();
  if (this.myFile != null) {
    this.fileupload = this.myFile.name;
  } else {
    this.fileupload = "";
  }

  this.data = {
    tma_code:this.form.controls.code.value,
    tma_name:this.form.controls.name.value,
    tma_vendor:this.form.controls.vender.value,
    tma_detail:this.form.controls.spec.value,
    tma_ct:0,
    product:this.selectedItems,
    serial:this.form.controls.serial.value,
    model:this.form.controls.model.value,
    filename:this.fileupload,
    filename_:this.fileupload_,
    user:this.arr_user
  }
  // insert data
  this.httpservice.fetchpost('insertDataMachine.php', this.data, (cb) => {});
  this.getStartData();
  //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }
  if (this.myFile_ != null) {
    this.uploadPhoto_(this.myFile_);
  }

  this.form.reset();
  this.user_selected.reset();
  this.picture = null;
}

search(){
  //this.cksearch=true;
  clearInterval(this.setId);
  this.httpservice.fetchget('getJSON_machine.php?key='+this.key,(machine) => {
    this.rows = machine;
    console.log('------this.setId------', this.machines,this.setId);
  });
  this.machineCtrl.reset();
  this.key="";
  }

  ngOnInit() {
    this.form = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      vender: [null, Validators.compose([Validators.required])],
      ct: [null, Validators.compose([Validators.required])],
      serial: [null, Validators.compose([Validators.required])],
      model: [null, Validators.compose([Validators.required])],
      spec: [null, Validators.compose([Validators.required])],
      pictureInput: [null, Validators.compose([Validators.required])],
      fileInput : [null, Validators.compose([Validators.required])]
    });

  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }

   attachFile_(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc_ = reader.result;
      console.log(_self.imageSrc_);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile_ = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile_.name);
   }


    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tma_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }
  uploadPhoto_(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi_}`);
    request.send(formData);
  }

  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(machineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  openQrDialog(){

    this.httpservice.fetchget('print-machine-qr.php?id='+this.id,data=>{
      const printContent = document.getElementById("print-section");
      const WindowPrt = window.open('', '', 'left=0,top=0,width=700,height=400,toolbar=0,scrollbars=0,status=0');
      WindowPrt.document.write(printContent.innerHTML);
      WindowPrt.document.write('<title>Operator QR-Code</title>');
      WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.css">');
      WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.min.css">');
      WindowPrt.document.close();
      WindowPrt.onload = function() {
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
      };
    });

}//end print

  openEditDialog(){
    let dialogRef = this.dialog.open(machineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value !=null && this.form.controls.name.value !="" && this.form.controls.name.value !=undefined){
          this.edit();
        }else{
          this.warningDialog('Please fill in Code, Name, CT Value , FG part no,Administrator!');
        }
      
       // console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog(){
    let dialogRef = this.dialog.open(machineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value !=null && this.form.controls.name.value !="" && this.form.controls.name.value !=undefined && this.selectedItems.length>0){
          this.save();
        }else{
          this.warningDialog('Please fill in Code, Name, CT Value ,FG part no, Administrator!');
        }
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {

    let dialogRef = this.dialog.open(WarningMachineDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'machine-dialog',
  templateUrl: 'dialog.html',
})
export class machineDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<machineDialog>) {}
}

//warning
@Component({
  selector: 'warning-machine-dialog',
  templateUrl: 'warning.html',
})
export class WarningMachineDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningMachineDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/machine/machine.ts